
import React from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Upload, X } from "lucide-react";

interface LogoUploadSectionProps {
  logo: File | null;
  onLogoChange: (file: File | null) => void;
}

export const LogoUploadSection: React.FC<LogoUploadSectionProps> = ({
  logo,
  onLogoChange
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      // Validar tipo de archivo
      const validTypes = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!validTypes.includes(file.type)) {
        alert('Por favor selecciona un archivo PNG, JPG o JPEG');
        return;
      }
      onLogoChange(file);
    }
  };

  const handleRemoveLogo = () => {
    onLogoChange(null);
  };

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">Agregar logo</Label>
      
      {/* Área de carga del logo */}
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 bg-gray-50">
        {logo ? (
          /* Vista previa del logo */
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded flex items-center justify-center">
                <img
                  src={URL.createObjectURL(logo)}
                  alt="Logo preview"
                  className="w-10 h-10 object-contain rounded"
                />
              </div>
              <div>
                <span className="text-sm font-medium text-gray-900">Logo</span>
                <p className="text-xs text-gray-500">{logo.name}</p>
              </div>
            </div>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={handleRemoveLogo}
              className="h-8 w-8 p-0 bg-orange-400 hover:bg-orange-500 text-white rounded-full"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ) : (
          /* Área de carga */
          <div className="text-center">
            <div className="flex justify-center mb-3">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                <Upload className="h-6 w-6 text-gray-400" />
              </div>
            </div>
            <div className="text-gray-600 text-sm mb-2">Agregar logo</div>
            <Input
              type="file"
              accept=".png,.jpg,.jpeg"
              onChange={handleFileChange}
              className="hidden"
              id="logo-upload"
            />
            <Label
              htmlFor="logo-upload"
              className="cursor-pointer text-blue-600 hover:text-blue-700 text-sm underline"
            >
              Seleccionar archivo
            </Label>
          </div>
        )}
      </div>

      {/* Mensaje descriptivo */}
      <p className="text-xs text-gray-500 leading-relaxed">
        Selecciona tu logo en formato png, jpg o jpeg para darle más estilo a tus facturas y tickets. 
        El tamaño sugerido es de 178 px de ancho y 51 px de alto.
      </p>
    </div>
  );
};
